import { ITagLeafCustomBucketDef } from '../../../../utils/apollo/graphqlSchema';
import {
  DescriptionTerm,
  DetailsDescription,
  EntityTitle,
  NodeDetails,
  NodeDetailsHeader,
  NodeDetailsMain,
} from '../EntitySelectionPanelUI';
import { DescriptionIcon } from '../node/NodeIcon';
import { usePanelStateContext } from '../context';
import { bucketKindLabel } from '../utils';

interface IProps {
  node: ITagLeafCustomBucketDef;
}

const CustomBinningDetails = ({ node }: IProps) => {
  const { selectNodeHandler } = usePanelStateContext();

  return (
    <NodeDetails>
      <NodeDetailsHeader onClick={() => selectNodeHandler(node)}>
        <DescriptionIcon node={node} />
        <EntityTitle>{node.name}</EntityTitle>
      </NodeDetailsHeader>
      <NodeDetailsMain>
        <DetailsDescription>
          <DescriptionTerm>Type:</DescriptionTerm>
          {bucketKindLabel[node.kind]}
        </DetailsDescription>
      </NodeDetailsMain>
    </NodeDetails>
  );
};

export default CustomBinningDetails;
